define('responsive-gameday/helpers/EventDistributor',['require','exports','module','extant/extant','GameDayCore','GameDayCore/GDModel/enums/events/EventTypes','GameDayCore/GDUtil/window/Logg','message-service/message-service'],function(require,exports,module){
	var exists = require('extant/extant'),
		GameDayCore = require('GameDayCore'),
		eventEnums=require('GameDayCore/GDModel/enums/events/EventTypes'),
		logg = require("GameDayCore/GDUtil/window/Logg"),
		MessageService = require('message-service/message-service');
	function GDEventDistributor() {}

	GDEventDistributor.prototype = {
		events: {
			CHANGE_TAB_VIEW: "changeTabView",
			OPEN_MATCHUPS_VIEW: "openMatchupsView",
			OPEN_BOX_VIEW: "openBoxView",
			OPEN_PLAYS_VIEW: "openPlaysView",
			OPEN_VIDEOS_VIEW: "openVideosView",
			OPEN_FIELD_VIEW: "openFieldView",
			CLOSE_MATCHUPS_VIEW: "closeMatchupsView",
			CLOSE_BOX_VIEW: "closeBoxView",
			CLOSE_PLAYS_VIEW: "closePlaysView",
			CLOSE_VIDEOS_VIEW: "closeVideosView",
			CLOSE_FIELD_VIEW: "closeFieldView",
			HIDE_MATCHUPS_CONTAINER: "hideMatchUpsContainer",
			SHOW_MATCHUPS_CONTAINER: "showMatchupsContainer",
			OPEN_PLAYER_CARD: "openPlayerCard",
			PLAY_VIDEO_BY_ID: "playVideoById",
			INITIATE_VIDEO_AD: "initiateVideoAd",
			CLOSE_VIDEO_AD: "closeVideoAd",
			GD_PAGE_ADS_UPDATED: "gdPageAdsUpdated",
			UPDATE_CHYRON_ADS: "updateChyronAds",
			PLAY_JINGLE: "playJingle"
		},


		transportGameSceneEvents: function(evts) {
			for (var i = 0, l = evts.length; i < l; i++) {
				var pairing = evts[i];

				setTransport(pairing.incoming, pairing.outgoing);
			};

			function setTransport(oldEvt, newEvt) {
				MessageService.addListener(oldEvt, function() {
					logg.log("republishing " + oldEvt + " as " + newEvt);
					MessageService.publish(newEvt);
				});
			}
		},

		transportUserEvents: function(evtArray) {

            for (var i = 0, l = evtArray.length; i < l; i++) {
                translateEvent(evtArray[i].incoming, evtArray[i].outgoing);
            }

			function translateEvent($in, $out) {
				MessageService.addListener($in, function(payload, evt) {
					logg.log("publishing " + $in + " as " + $out);
					MessageService.publish($out, payload);
				})
			}
		},

		transportWindowEvents: function(evts) {
			if (exists(parent, "window.addEventListener")) {
				parent.window.addEventListener("message", handleWindowMessage, false);
			} else if (exists(parent, "window.attachEvent")) {
				parent.window.attachEvent("message", handleWindowMessage);
			} else {
				$.log("Unable to attach listener to parent.window");
			};

			function handleWindowMessage(message) {
				var msg = message.data.split("~"),
					evt = msg.shift();

				for (var i = 0, l = evts.length; i < l; i++) {
					if (evt === evts[i].incoming) {

						logg.log("Assinging " + evts[i].incoming + " event to " + evts[i].outgoing);
						MessageService.publish(evts[i].outgoing, { data: msg });
						return;
					}
				}
			};
		},

		/** NOTE for require conversion
		 The message-service module now will bind the handler function to the scope of the
		 addListener call.  So, if we pass in the component during the event binding phase
		 in kickstart, the component will be able to reference it's instance properly.
		 ex :
		 MessageService.addListener(evtPairs[i].scope ,evtPairs[i].event, evtPairs[i].handler);
		 This way we can move the hide/show/setTab methods to the prototypes of their components.
		 */
        addSubscribtions: function(evtPairs,scope) {
			for (var i = 0, l = evtPairs.length; i < l; i++) {
                MessageService.addListener.call(evtPairs[i].scope || scope || MessageService,evtPairs[i].event, evtPairs[i].handler);
			}
		},
		/**  NOTE also... don't need the scope here, since it's scrictly destructive **/
		removeSubscribtions: function(evtPairs) {
			for (var i = 0, l = evtPairs.length; i < l; i++) {
				MessageService.removeListener(evtPairs[i].event, evtPairs[i].handler);
			}
		}
	};

	return GDEventDistributor;
});
